import PQueue from 'p-queue';
import { ONE_MEBIBYTE } from '@lucidlink/uicore';
import { concatBuffers } from '#context/file-contexts-common';
import { optimizeRangeIntoChunks } from './optimizeRangeIntoChunks';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-22765 while doing the error handling you also
// add the following:
// - validation of arguments
// - error handling / rejecting - we need to somehow handle the error that can be thrown from webfs and cancel the queue
export const downloadRangedChunkWithQueue = async ({ chunkSize = BigInt(ONE_MEBIBYTE), downloadChunk, end, maxConcurrentChunks = 6, start, }) => {
    // Current project NodeJS version does not support Promise.withResolvers, so the
    // alternative is this piece of crap. Also TS doesn't have a specific typing for
    // Promise constructor arguments so that's that. Only doing this because I want to
    // have unit tests for this function, otherwise this is not needed as all modern
    // browsers support it already.
    let completionResolve;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Explanation above^
    let completionReject;
    const completionPromise = new Promise((resolve, reject) => {
        completionResolve = resolve;
        completionReject = reject;
    });
    const downloadedChunks = new Map();
    const totalSize = Number(end - start);
    const downloadQueue = new PQueue({
        concurrency: maxConcurrentChunks,
    });
    const chunks = optimizeRangeIntoChunks(start, end, chunkSize);
    for (const { end: chunkEnd, start: chunkStart } of chunks) {
        void downloadQueue.add(async () => {
            const buffer = new Uint8Array(Number(chunkEnd - chunkStart));
            try {
                const dataReadSize = await downloadChunk(buffer, BigInt(chunkStart));
                const actualChunkData = buffer.slice(0, dataReadSize);
                downloadedChunks.set(BigInt(chunkStart), actualChunkData);
            }
            catch (error) { }
        });
    }
    downloadQueue.on('idle', () => {
        const chunks = [...downloadedChunks];
        const sortedChunks = chunks.sort((chunkA, chunkB) => Number(chunkA[0] - chunkB[0]));
        const finalChunk = concatBuffers(sortedChunks.map((chunk) => chunk[1]));
        // Instead of rejecting maybe we can try to recover from this
        if (finalChunk.length !== totalSize) {
            completionReject(new Error('Final buffer size does not match expected size.'));
            return;
        }
        completionResolve({ chunk: finalChunk });
    });
    return completionPromise;
};
